import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../styles/MemberLogin.css';
import { useNavigate } from 'react-router-dom';

const EDCCOtpLogin = () => {
     const navigate = useNavigate();

    const handleSignin = () => {
    navigate('/EDCCterms-conditions');
  };
  return (
    <>
      <section className="member-login-section">
        <Container>
          <div className="login-box">
            <Row>
              {/* Left Side */}
              <Col md={6} className="login-left mb-4 mb-md-0">
                <div className="login-form-container">
                  <h4 className="login-title">
                    EDCC Login <span className="dropdown-arrow">↓</span>
                  </h4>
                </div>
              </Col>

              {/* Right Side (OTP Form) */}
              <Col md={6}>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">Enter OTP</Form.Label>
                    <div className="d-flex gap-2">
                      {[1, 2, 3, 4].map((digit) => (
                        <Form.Control
                          key={digit}
                          type="text"
                          maxLength="1"
                          className="edcc-otp-digit text-center"
                        />
                      ))}
                    </div>
                  </Form.Group>

                  <div className="mb-3">
                    <Button variant="link" className="custom-link p-0">Resend OTP</Button>
                  </div>

                  <div className="text-center mb-2">
                    <Button className="custom-btn w-100" onClick={handleSignin}>SIGN IN</Button>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default EDCCOtpLogin;
